import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { AppDispatch, RootState } from '../../store';
import { FaHeart, FaStar } from 'react-icons/fa';
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import { IoMdShare } from 'react-icons/io';
import { CiLocationOn } from "react-icons/ci";

import { Image } from '../../types';
import { FaArrowLeftLong, FaPeopleRoof } from 'react-icons/fa6';
import { addFavorite, deleteFavorite, fetchFavorites } from '../../features/home/favSlice';
import Cookies from 'js-cookie';
import { PiHeartFill } from 'react-icons/pi';
import toast from 'react-hot-toast';
import LoginPopup from '../ui/LoginPopup';
import Reviews from '../ui/Reviews';
import DateSetter from './DateSetter';
import LocationButton from '../ui/LocationButton';
import { fetchOptionalServices } from '../../features/admin/additionalServiceSlice';
import { setOptionalServices } from '../../features/home/bookingSlice';
import { fetchPlaceReviews } from '../../features/admin/placeSlice';


const PlaceDetailsPage = () => {
	const { placeId } = useParams()
	const [thumbsSwiper, setThumbsSwiper] = useState<any>(null)
	const [timeError, setTimeError] = useState<string>("")
	const { t } = useTranslation();
	const dispatch = useDispatch<AppDispatch>();
	const [showLoginModal, setShowLoginModal] = useState(false);
	const { place, reviews } = useSelector((state: RootState) => state.placeSlice);
	const { favorites } = useSelector((state: RootState) => state.favoriteslice);
	const { OptionalServices } = useSelector((state: RootState) => state.OptionalServiceSlice);
	const [showDateSetter, setShowDateSetter] = useState(false);
	const { checkIn, checkOut, duration } = useSelector((state: RootState) => state.bookingSlice);
	const userId = Cookies.get('userId');
	const navigate = useNavigate()
	const noDates = place?.type==="Hall"?(!checkIn || !duration): (!checkIn || !checkOut);
	const selectedServices = useSelector(
		(state: RootState) => state.bookingSlice.selectedOptionalService
	);
	useEffect(() => {
		if (placeId && userId) {
			dispatch(setOptionalServices([]))
			dispatch(fetchOptionalServices({ placeId, userId }))
			dispatch(fetchPlaceReviews(Number(placeId)))
		}
	}, [dispatch, placeId, userId])
	const middleRef = useRef<HTMLDivElement | null>(null);
	useEffect(() => {
		middleRef.current?.scrollIntoView({ behavior: "smooth" });
	}, []);

	const favoriteItem = [
		...(favorites?.stays || []),
		...(favorites?.halls || [])
	].find((fav: any) => fav?.place?.id === place?.id && fav?.type === "Place");


	const isFavorite = Boolean(favoriteItem);
	const handleAddToFavorite = async () => {
		if (!userId) return setShowLoginModal(true);
		await dispatch(addFavorite({
			itemId: place?.id,
			userId,
			type: "Place",
		}));
		dispatch(fetchFavorites({ id: userId }));
	};

	const handleRemoveFromFavorite = () => {
		if (!userId || !favoriteItem) return;

		dispatch(deleteFavorite({
			itemId: place?.id,
			userId,
			type: "Place"
		}));
		dispatch(fetchFavorites({ id: userId }));
	};
	const handleShare = () => {
		navigator.clipboard.writeText(window.location.href)
			.then(() => {
				toast.success(t("link_copied_success"));
			})
			.catch(() => {
				toast.error(t("link_copy_failed"));
			});
	};

	const toggleService = (service: { id: number; price: number }) => {
		let updatedServices;
		const exists = selectedServices.some(s => s.id === service.id);

		if (exists) {
			updatedServices = selectedServices.filter(s => s.id !== service.id);
		} else {
			updatedServices = [...selectedServices, service];
		}

		dispatch(setOptionalServices(updatedServices));
	};

	return (
		<div>
			<div className="padding-container main-prop bg-white" ref={middleRef}>
				<div className=" py-10">
					<div className="flex flex-col md:flex-row gap-8">
						<div className="md:w-1/2 w-full flex flex-col items-start ">
							<LocationButton link={`/place/${place?.id}/map-view`} />
							<div className=' flex justify-between py-3 border-b border-grayColor space-y-1 w-full items-start '>
								<div className="space-y-2 ">
									<h2 className="text-3xl font-bold "> {place?.title}</h2>
									<p className="text-textSecond flex gap-1 items-center text-sm"><CiLocationOn /> {place?.location || 'No location info'}</p>
									{/* layout */}
									{place?.type === "Stay" && place.subCategory.id !== 1 &&
										<div className=" flex gap-1 text-blue-700  ">
											{place?.numberOfRooms && place?.numberOfRooms > 0 &&
												<p>
													{place?.numberOfRooms === 1 ? t("a-room") : place?.numberOfRooms === 2 ? t("2-room") : place?.numberOfRooms + " " + t("a-rooms")}
												</p>
											}
											{place?.numberOfHalls && place?.numberOfHalls > 0 ?
												<p>
													+ {place?.numberOfHalls} {t("palce-Hall")}
												</p> : <p>{t("without-placeHall")}</p>
											}
										</div>
									}
									<div className=' flex gap-1 text-secondry items-center'>
										<FaStar />
										{place?.rate}
										<span className=' text-sm text-textSecond'>{`(${reviews?.length} ${t("reviews")})`}</span>
									</div>
									{place?.type === "Hall" &&
										<div className=' flex gap-1 text-secondry items-center'>
											<FaPeopleRoof />
											<p className=' text-sm text-textSecond'>
												{t("enough-for")} {place.numberOfPeoples} {t("person")}
											</p>
										</div>
									}
								</div>
								<div className="flex items-center gap-3 ">
									{isFavorite ? (
										<button
											onClick={(e) => {
												e.preventDefault();
												e.stopPropagation();
												handleRemoveFromFavorite();
											}}
											className="text-red-600 hover:text-red-500 bg-white rounded-full shadow-md p-2 text-xl"
										>
											<PiHeartFill />
										</button>
									) : (
										<button
											onClick={(e) => {
												e.preventDefault();
												e.stopPropagation();
												handleAddToFavorite();
											}}
											className="text-textSecond hover:text-red-500 bg-white rounded-full shadow-md p-2 text-xl"
										>
											<FaHeart />
										</button>

									)}
									<button onClick={handleShare} className="text-textSecond hover:text-red-500 bg-white rounded-full shadow-md p-2 text-xl">
										<IoMdShare />
									</button>
								</div>
							</div>
							<section className="py-3 border-b border-grayColor w-full ">
								<h2 className="text-2xl font-semibold mb-4">{t("amenities")}</h2>
								<div className="grid grid-cols-2  gap-4">

									{place?.amenities.length === 0 && <div className=" text-textSecond">{t("no-services")}</div>}
									{place?.amenities.slice(0, 4).map((amenity) => (
										<div key={amenity.id} className="flex items-center gap-2   rounded-lg">
											<img src={amenity.image} alt={amenity.title} className="w-6 h-6" />
											<span className="text-sm text-gray-800">{amenity.title}</span>
										</div>
									))}
								</div>
								{place && place?.amenities?.length > 3 && <a
									href="#amenities-section"
									className="mt-1 text-sm flex items-center text-secondry gap-1"
								>
									{t("view-more-service")} <FaArrowLeftLong />
								</a>}
							</section>
							<section className="py-3 border-b border-grayColor w-full">
								<h2 className="text-2xl font-semibold mb-4">{t("set-dates")}</h2>
								{(showDateSetter || noDates) && (place?.type === "Hall" ? <DateSetter hourTime={true} /> : <DateSetter />)}
								<p className=' text-sm text-red-600'>{timeError}</p>
								{checkIn && (checkOut|| duration) && !showDateSetter && (
									<div className="mt-4 text-sm text-textSecond">

										<button
											onClick={() => setShowDateSetter(true)}
											className="ml-2 text-secondry underline"
										>
											{t("edit-dates")}
										</button>
									</div>
								)}
							</section>

							<section className='flex xs:flex-col sm:flex-row gap-5 justify-between  w-full mt-3'>
								<div className=' flex-1'>
									<p className=' text-sm text-textSecond'>{t("start-from")}</p>
									<div className="text-lg text-nowrap font-bold text-secondry">
										{place?.type === "Stay" && (
											place?.discountPercentage > 0 ? (
												<div className="flex gap-2 items-baseline">
													<span>
														{place?.currencyCode}{" "}
														{(
															(place?.price || 0) -
															((place?.price || 0) * (place.discountPercentage || 0)) / 100
														).toFixed(2)}{" "}
														{t("per-night")}
													</span>

													<span className="text-sm font-semibold line-through text-red-600">
														{place?.currencyCode} {place?.price} {t("per-night")}
													</span>
												</div>
											) : (
												<span>
													{place?.currencyCode} {place?.price} {t("per-night")}
												</span>
											)
										)}


										{place?.type === "Hall" && Number(duration) === 1 && (
											place?.discountPercentage&&place?.discountPercentage > 0 ? (
												<div className="flex gap-2 items-baseline">
													<span>
														{place?.currencyCode}{" "}
														{(
															(place?.price || 0) -
															((place?.price || 0) * (place?.discountPercentage || 0)) / 100
														).toFixed(2)}{" "}
														{t("per-morning")}
													</span>

													<span className="text-sm font-semibold line-through text-red-600">
														{place?.currencyCode} {place?.price} {t("per-morning")}
													</span>
												</div>
											) : (
												<span>
													{place?.currencyCode} {place?.price} {t("per-morning")}
												</span>
											)
										)}
										{place?.type === "Hall"&& Number(duration)===2 && (
											place?.discountNightPercentage&&place?.discountNightPercentage > 0 ? (
												<div className="flex gap-2 items-baseline">
													<span>
														{place?.currencyCode}{" "}
														{(
															(place?.priceNight || 0) -
															((place?.priceNight || 0) * (place.discountNightPercentage || 0)) / 100
														).toFixed(2)}{" "}
														{t("per-afternoon")}
													</span>

													<span className="text-sm font-semibold line-through text-red-600">
														{place?.currencyCode} {place?.priceNight} {t("per-afternoon")}
													</span>
												</div>
											) : (
												<span>
													{place?.currencyCode} {place?.price} {t("per-afternoon")}
												</span>
											)
										)}
									</div>
								</div>
								{/*here checking with id one for if it hotel or no  */}
								{place?.subCategory.id === 1 ? (
									userId ?
										!checkIn || !checkOut ? (
											<button
												onClick={() => setTimeError(t("enter-time"))}
												className="text-white text-lg text-center bg-primary px-5 py-2 rounded-xl flex-1"
											>
												{t("rooms-available")}
											</button>
										) : (
											<button
												onClick={() => {
													setTimeError("");
													navigate(`/place/${place?.id}/rooms`);
												}}
												className="text-white text-lg text-center bg-primary px-5 py-2 rounded-xl flex-1"
											>
												{t("rooms-available")}
											</button>
										)
										: (
											<button
												onClick={() => setShowLoginModal(true)}
												className="text-white text-lg text-center bg-primary px-5 py-2 rounded-xl flex-1"
											>
												{t("rooms-available")}
											</button>
										)
								) : (
									userId ?
										checkIn && (checkOut||duration) ? (
											<Link
												to={`/place/${place?.id}/check-out`}
												className="text-white text-lg text-center bg-primary px-5 py-2 rounded-xl flex-1"
											>
												{t("book-now")}
											</Link>
										) : (
											<button
												onClick={() => setTimeError(t("enter-time"))}
												className="text-white text-lg text-center bg-primary px-5 py-2 rounded-xl flex-1"
											>
												{t("book-now")}
											</button>
										) :
										<button
											onClick={() => setShowLoginModal(true)}
											className="text-white text-lg text-center bg-primary px-5 py-2 rounded-xl flex-1"
										>
											{t("book-now")}
										</button>
								)}



							</section>
						</div>
						<div className="md:w-1/2 w-full space-y-2">
							<Swiper
								spaceBetween={8}
								thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
								modules={[Thumbs]}
								className="h-[250px] sm:h-[400px]  overflow-hidden"
							>
								{place?.images && place.images.length > 0 ? (place?.images.map((img: Image, i) => (
									<SwiperSlide key={i}>
										<img src={img.url} alt={`slide-${i}`} className="h-full w-full object-cover" />
									</SwiperSlide>
								))) : (<SwiperSlide><img src={"/asset/modern-commercial-building.webp"} alt={"place-image"} className="h-full w-full object-cover" /></SwiperSlide>)}
							</Swiper>

							<Swiper
								onSwiper={setThumbsSwiper}
								spaceBetween={8}
								slidesPerView={4.5}
								freeMode
								watchSlidesProgress
								modules={[FreeMode, Thumbs]}
								className="h-20"
							>
								{place?.images.map((img, i) => (
									<SwiperSlide key={i}>
										<img
											src={img.url}
											alt={`thumb-${i}`}
											className="h-full w-full object-cover  border hover:border-primary transition"
										/>
									</SwiperSlide>
								))}
							</Swiper>
						</div>

					</div>
					<div>
						<section className="mt-10">
							<h2 className="text-2xl font-semibold mb-4">{t("description")}</h2>
							<p className="text-textSecond leading-relaxed">{place?.details}</p>
						</section>
						{place?.subCategory.id === 1 &&
							<section className="mt-10">
								<h2 className="text-2xl font-semibold mb-4">{t("rooms")}</h2>
								<div className=' flex gap-5'>
									{place.roomTypes?.map((item, index) => (
										<p key={index} className='  text-textSecond border border-textSecond rounded-lg px-2 py-1'>{item}</p>
									))}
								</div>
							</section>
						}


						<section id="amenities-section" className="mt-10  w-full">
							<div className="mt-10">
								<h2 className="text-2xl font-semibold mb-4">{t("amenities")} </h2>
								<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">

									{place?.amenities.length === 0 && <div className=" text-textSecond">{t("no-services")}</div>}
									{place?.amenities.map((amenity) => (
										<div key={amenity.id} className="flex items-center gap-3  rounded-lg">
											<img src={amenity.image} alt={amenity.title} className="w-6 h-6" />
											<span className="text-sm text-nowrap text-gray-800">{amenity.title}</span>
										</div>
									))}
								</div>
							</div>
						</section>
						{/* Additional Services */}
						{OptionalServices.length !== 0 &&
							<section className="mt-10 w-full"> <h2 className="text-2xl font-semibold mb-4">{t("additional-service")} </h2>
								<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
									{OptionalServices.map((service) => {
										const isSelected = selectedServices.some(s => s.id === service.id);
										return (
											<div
												key={service.id}
												onClick={() => toggleService({ id: service.id, price: service.price })}
												className={`flex border items-center gap-3 p-2 rounded-lg cursor-pointer transition 
        									${isSelected ? "border-primary bg-primary/10" : "hover:border-primary"}`}
											>
												<p className="text-sm text-nowrap text-gray-800">
													{service.title}
													<span className="text-textSecond text-xs">
														({service.price} {service.currencyCode})
													</span>
												</p>
											</div>
										)
									})}
								</div>
							</section>}
						{/* المراجعات */}
						<section className="mt-10 ">
							{reviews && <Reviews reviews={reviews} />}
						</section>
					</div>
				</div>
			</div>
			{
				showLoginModal && (
					<LoginPopup setShow={setShowLoginModal} />
				)
			}
		</div >
	)
}

export default PlaceDetailsPage